const productos = fetch("https://centurion.com.mx/producto/obtener_productos.php")
.then((res) => res.json());
export default await productos;